import React, { useState } from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import {
  Grid,
  Box,
  Card as MuiCard,
  CardContent as MuiCardContent,
  Typography,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import { SettingsApplications as SettingsApplicationsIcon } from "@mui/icons-material";
import { spacing } from "@mui/system";
import SetClaimState from "./SetClaimState";

const Card = styled(MuiCard)(spacing);
const CardContent = styled(MuiCardContent)(spacing);

const SidebarContainer = styled(Box)(({ theme }) => ({
  height: "fit-content",
  position: "sticky",
  top: theme.spacing(2),
}));

const Claims = () => {
  const [currentView, setCurrentView] = useState("setClaimState");

  const menuItems = [
    {
      title: "Set Claim State",
      icon: SettingsApplicationsIcon,
      view: "setClaimState",
    },
  ];

  const handleMenuClick = (item) => {
    setCurrentView(item.view);
  };

  const isActive = (view) => currentView === view;

  const renderContent = () => {
    if (currentView === "setClaimState") {
      return <SetClaimState />;
    }

    return <SetClaimState />;
  };

  return (
    <React.Fragment>
      <Helmet title="Admin Tools Claims" />

      <Typography variant="h3" gutterBottom>
        Admin Tools - Claims
      </Typography>

      <Grid container spacing={6}>
        <Grid item xs={12} md={3}>
          <SidebarContainer>
            <Card>
              <CardContent p={0}>
                <List component="nav" disablePadding>
                  {menuItems.map((item, index) => (
                    <React.Fragment key={item.view}>
                      <ListItemButton
                        onClick={() => handleMenuClick(item)}
                        selected={isActive(item.view)}
                        sx={{
                          py: 2,
                          px: 3,
                          "&.Mui-selected": {
                            backgroundColor: "primary.main",
                            color: "primary.contrastText",
                            "&:hover": {
                              backgroundColor: "primary.dark",
                            },
                            "& .MuiListItemIcon-root": {
                              color: "primary.contrastText",
                            },
                          },
                        }}
                      >
                        <ListItemIcon>
                          <item.icon />
                        </ListItemIcon>
                        <ListItemText primary={item.title} />
                      </ListItemButton>
                      {index < menuItems.length - 1 && <Divider />}
                    </React.Fragment>
                  ))}
                </List>
              </CardContent>
            </Card>
          </SidebarContainer>
        </Grid>

        <Grid item xs={12} md={9}>
          <Box>{renderContent()}</Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default Claims;
